import { Injectable } from "@angular/core";
import { IpointService } from "@core-interfaces/services/point";
import { BehaviorSubject, Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PointManager implements IpointService {
    private pointsSubject = new BehaviorSubject<string>('');
    points$ = this.pointsSubject.asObservable();

    setPoints(points: string): void {
        this.pointsSubject.next(points);
    }
}